import {
    getVersionReleaseNotesEntries,
    hasVersionReleaseNotesEntries,
} from "@dashboard/shared/utils/versionReleaseNotes";

import { OtaFile } from "../types";

export function getOtaFileReleaseNotes(otaFile: OtaFile): NonNullable<OtaFile["changes"]> {
    return getVersionReleaseNotesEntries(otaFile.changes, otaFile.version);
}

export function hasOtaFileReleaseNotes(releaseNotes: NonNullable<OtaFile["changes"]>): boolean {
    return hasVersionReleaseNotesEntries(releaseNotes);
}
